<template>
    <button :type="type" :disabled="loading || disabled" :aria-busy="loading" :class="buttonClasses">
        <slot />
        <span v-if="loading" class="btn-spinner mr-2" aria-hidden="true"></span>
        <template v-if="icon && !loading">
            <i :class="[icon, iconClasses]"></i>
        </template>
    </button>
</template>

<script setup>
const props = defineProps({
    loading: {
        type: Boolean,
        default: false
    },
    disabled: {
        type: Boolean,
        default: false
    },
    type: {
        type: String,
        default: 'button'
    },
    icon: {
        type: String,
        default: null
    },
    iconPos: {
        type: String,
        default: 'left'
    },
    iconClass: {
        type: String,
        default: ''
    },
    size: {
        type: String,
        default: 'md'
    },
    severity: {
        type: String,
        default: ''
    },
    rounded: {
        type: Boolean,
        default: false
    }
})

const buttonClasses = computed(() => {
    const classes = ['btn']

    if (props.size) {
        classes.push(`btn-${props.size}`)
    }

    if (props.severity) {
        classes.push(`btn-${props.severity}`)
    }

    if (props.rounded) {
        classes.push('btn-rounded')
    }

    return classes.join(' ')
})

const iconClasses = computed(() => {
    const classes = []

    if (props.iconPos === 'left') {
        classes.push('order-first')
    } else if (props.iconPos === 'right') {
        classes.push('order-last')
    }

    if (props.iconClass) {
        classes.push(props.iconClass)
    }

    return classes.join(' ')
})
</script>
